module.exports = __webpack_public_path__ + "img/kta-back-card-2025.ad6a581d.jpg";